import React, { useState, useEffect, useRef } from 'react';
import Select, { components } from 'react-select';
import { Tab, Nav } from 'react-bootstrap';
import { CSVLink } from "react-csv";
import { Dropdown } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import DatePicker from "react-datepicker";
import DateFormat from 'dateformat';
import ReactMultiSelectCheckboxes from '../common/ReactMultiSelectCheckboxes';
import MasterService from './../../services/MasterService';
import { Role, RoleId, ADMIN_ROLES, REJECT_STATUS, TENANT, TENANTS, Business, DEBOUNCE_DELAY_IN_MS, Vertical } from './../../config/constant';
import InputField from '../common/Input';
import { toast } from 'react-toastify';
import ls from "local-storage";
import { useNavigate } from 'react-router-dom';
import Loader from '../common/loader';
import 'react-tippy/dist/tippy.css'
import { Tooltip } from 'react-tippy';
import ChangeMappingPopUp from './ChangeMappingPopUp';
import WithRights from '../common/WithRights';
import { useHasRight } from '../hooks/useHasRights'
import ChangeTaggingPopUp from './ChangeTaggingPopUp';
import MarkInactivePopup from './MarkInactivePopup';
import RejectRequestPopup from './RejectRequestPopup';
import RejectRemapRequestPopup from './RejectRemapRequestPopup';
import { debounce } from '../../utils';
import { isEmpty } from '../../config/helper';
import ReportingManagerMenuList from './ReportingManagerMenuList';

// import secureStorage from '../../config/encrypt';
const { ValueContainer, Placeholder } = components;

const UserManagementDetail = (props) => {
  const csvLink = useRef();
  const allUserLink = useRef();
  const activeUserLink = useRef();
  const inActiveUserLink = useRef();
  const rejectedUserLink = useRef();
  const inProcessUserLink = useRef();
  const approvalPendingUserLink = useRef();
  const inactiveRequestsUserLink = useRef();
  const rejectedInactiveRequestsUserLink = useRef();
  const remapRequestsUserLink = useRef();
  const rejectedRemapRequestsUserLink = useRef();
  const lessFilterRef = useRef();
  const [pageCount, setPageCount] = useState(0)
  const [offset, setOffset] = useState(0);
  const [userList, setUserList] = useState({});
  const [CityData, setCityData] = useState(ls.get('filter_data').city_list_particular);
  const [RoleData, setRoleData] = useState(ls.get('filter_data').role_list_particular);
  const [StateData, setStateData] = useState(ls.get('filter_data').state_list_particular);
  const [userManagementSearch, setUserManagementSearch] = useState(ls.get('filter_data'));
  const [ReportingRole, SetReportingRole] = useState([]);
  const [AllReportingRole, SetAllReportingRole] = useState([]);
  const [ReportingTo, SetReportingTo] = useState([]);
  const [BusinessLine, SetBusinessLine] = useState([]);
  const [StateList, SetStateList] = useState([]);
  const [CityList, SetCityList] = useState([]);
  //const [dateRange, setDateRange] = useState([null, null]);
  const [dateRange, setDateRange] = useState([(ls.get('filter_data').start_created_date) ? new Date(ls.get('filter_data').start_created_date) : null, (ls.get('filter_data').end_created_date) ? new Date(ls.get('filter_data').end_created_date) : null]);
  const [startDate, endDate] = dateRange;
  const [dateRange1, setDateRange1] = useState([(ls.get('filter_data').start_approved_date) ? new Date(ls.get('filter_data').start_approved_date) : null, (ls.get('filter_data').end_approved_date) ? new Date(ls.get('filter_data').end_approved_date) : null]);
  //const [dateRange1, setDateRange1] = useState([null, null]);
  const [startDate1, endDate1] = dateRange1;
  const [TaggingOption, setTaggingOption] = useState([]);
  const [TaggingList, setTaggingList] = useState([]);
  //console.log(ls.get('current_status'));
  const [currentStatus, setCurrentStatus] = useState((ls.get('current_status')) ? ls.get('current_status') : '');
  //const [inactivePendingRequestStatus, setInactivePendingRequestStatus] = useState((ls.get('filter_data').inactive_pending_request) ? ls.get('filter_data').inactive_pending_request : 0);
  const [userCsvData, setUserCsvData] = useState([]);
  const [UserHistoryPopup, SetUserHistoryPopup] = useState(false);
  const [EsignApproveUserPopup, SetEsignApproveUserPopup] = useState(false);
  const [UserRoleHistoryList, setUserRoleHistoryList] = useState([]);
  const [UserAccountHistoryList, setUserAccountHistoryList] = useState([]);
  const [VendorHistoryList, setVendorHistoryList] = useState([]);
  const [ProgressionHistoryList, setProgressionHistoryList] = useState([]);
  const [reportingToHide, setReportingToHide] = useState(1);
  const [sortToggle, setSortToggle] = useState({
    'user_name': false,
    'reporting_role_name': false,
    'reporting_user_name': false,
    'created_date': false,
    'currentToggle': ''
  });
  const [errors, SetErrors] = useState({});
  const [allSelected, setAllSelected] = useState(false);
  const [changeMapping, setChangeMapping] = useState(false);
  const [changeTagging, setChangeTagging] = useState(false);
  const [markInactive, setMarkInactive] = useState(false);
  const [rejectRequest, setRejectRequest] = useState(false);
  const [rejectRemapRequest, setRejectRemapRequest] = useState(false);
  const [approveRemapRequest, setApproveRemapRequest] = useState(false);
  const [currentChangeManagerRole, setCurrentChangeManagerRole] = useState(undefined);
  const [isAnyUserSelected, setIsAnyUserSelected] = useState(false);
  const [BMGradingHistoryList, setBMGradingHistoryList] = useState([]);
  const [activeRoleId, setActiveRoleId] = useState('')
  const [loading, setLoading] = useState(false);
  const [exportOptionModal, setExportOptionModal] = useState(false);
  // const [tipOpen, setTipOpen] = useState(false);//removed warning
  // const [tipOpenId, setTipOpenId] = useState(0);//removed warning
  const [SubStatusOption, SetSubStatusOption] = useState([]);
  const [SubStatusData, setSubStatusData] = useState([]);
  const [AppUsageList, setAppUsageList] = useState([]);
  const [currentBusinessLine, setCurrentBusinessLine] = useState(undefined);
  const [currentBusinessUnitId, setCurrentBusinessUnitId] = useState(undefined);
  const [currentBusinessVerticalId, setCurrentBusinessVerticalId] = useState(undefined);
  const [exportFormField, setExportFormField] = useState({})
  const [export_field_data, setExportFieldData] = useState({ "Role Details": [], "Basic Details": [], "Forms": [] })
  const { rightsStatus, adminRoleId } = useHasRight(['edit_agent', 'total_bucket', 'active_bucket', 'approval_pending_bucket', 'in_progress_bucket', 'inactive_bucket', 'rejected_bucket', 'inactive_request_bucket']);
  const editAgentRight = rightsStatus['edit_agent']
  const [SignatureData, setSignatureData] = useState([]);

  const [dropDownLoaders, setDropDownLoaders] = useState({ reporting_manager: false });
  const [reportingManagerHasNext, setReportingManagerHasNext] = useState(false);
  const [reportingManagerLoadingMore, setReportingManagerLoadingMore] = useState(false);
  const [reportingManagerCurrentPage, setReportingManagerCurrentPage] = useState(1);
  const reportingManagerQueryRef = useRef({  role_id: null,  search_text: "",  page_limit: 500 });
    
  const historyLead = useNavigate();

   const debouncedGetUsers = useRef(
        debounce((...args) => {
          getRoleUsersList(...args);
  }, DEBOUNCE_DELAY_IN_MS)).current;
  
  useEffect(() => {
    return () => {
      debouncedGetUsers.cancel();
    };
  }, [debouncedGetUsers]);

  const debouncedGetUserList = useRef(
    debounce((params, page, status, sortToggle) => {
      getUserList(params, page, status, sortToggle);
    }, DEBOUNCE_DELAY_IN_MS)
  ).current;

  useEffect(() => {
    return () => {
      debouncedGetUserList.cancel();
    };
  }, [debouncedGetUserList]);

  useEffect(() => {
    getUserList(userManagementSearch, offset, currentStatus, sortToggle);
    getAllRoleList();
    getBusinessLineList();
    getStateList();
    statusHandle();
    const reportingRoleId = userManagementSearch.reporting_role_id;    
    getRoleUsersList(reportingRoleId);  
    getCityList(userManagementSearch.city);
    handleChangeMultiSel("role_id", RoleData);
    handleDpdOptionChange("reportee_type", { value: 'all_reportee', label: 'All Reportee' });
    //handleSecondaryReportingFilter();
    if (TENANT !== TENANTS.PH) {
      getSubStatusList();
    }
    if(!isEmpty(userManagementSearch?.reporting_role_id))setReportingToHide(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let atLeadOneSelected = false;

    if (userList?.user_list && userList?.user_list.length) {
      let tempAllSelected = true;
      userList.user_list.forEach((ele) => {
        if (!ele.is_selected && (isIndependentSelectionTab || ele.reporting_to_role === currentChangeManagerRole)) {
          tempAllSelected = false;
        }
        if (ele.is_selected) {
          atLeadOneSelected = true;
        }
      })
      setAllSelected(tempAllSelected);
    } else {
      setAllSelected(false);
      setCurrentChangeManagerRole(undefined);
      setCurrentBusinessLine(undefined);
      setCurrentBusinessUnitId(undefined);
      setCurrentBusinessVerticalId(undefined);
    }

    if (!atLeadOneSelected) {
      setAllSelected(false);
      setCurrentChangeManagerRole(undefined);
      setCurrentBusinessLine(undefined);
      setCurrentBusinessUnitId(undefined);
      setCurrentBusinessVerticalId(undefined);
      setIsAnyUserSelected(false)
    } else {
      setIsAnyUserSelected(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userList])

  useEffect(() => {
    setTaggingList([]);
  }, [RoleData])

  const isIndependentSelectionTab = userManagementSearch.inactive_pending_request === 1 || userManagementSearch.remap_pending_request === 1;

  const handleSelectAll = () => {
    let tempUserList = { ...userList };
    if (isIndependentSelectionTab) {
      if (tempUserList?.user_list) {
        tempUserList.user_list = tempUserList.user_list.map((ele) => ({
          ...ele,
          is_selected: !allSelected,
        }));
      }
      setUserList(tempUserList);
      setAllSelected(!allSelected);
      return;
    }
    let tempCurrentChangeManagerRole = currentChangeManagerRole;
    let tempCurrentBusinessLine = currentBusinessLine;
    let tempCurrentBusinessUnitID = currentBusinessUnitId;
    let tempCurrentBusinessVerticalID = currentBusinessVerticalId;
    if (tempUserList?.user_list) {
      if (tempCurrentChangeManagerRole === undefined) {
        tempCurrentChangeManagerRole = tempUserList.user_list.find(ele => ele.reporting_to_role)?.reporting_to_role || undefined;
        tempCurrentBusinessLine = tempUserList.user_list.find(ele => ele.business_line)?.business_line || undefined;
        tempCurrentBusinessUnitID = tempUserList.user_list.find(ele => ele.business_unit_id)?.business_unit_id || undefined;
        tempCurrentBusinessVerticalID = tempUserList.user_list.find(ele => ele.business_vertical_id)?.business_vertical_id || undefined;
      }

      if (!allSelected) {
        let isAnyOneSelected = false;
        tempUserList.user_list = tempUserList.user_list.map((ele) => {
          if (tempCurrentChangeManagerRole && tempCurrentBusinessLine && ele.reporting_to_role === tempCurrentChangeManagerRole && ele.business_line === tempCurrentBusinessLine && ele.business_unit_id === tempCurrentBusinessUnitID) {
            isAnyOneSelected = true;
            return {
              ...ele,
              is_selected: true,
            }
          } else {
            return {
              ...ele,
              is_selected: false,
            }
          }
        })

        if (!isAnyOneSelected) {
          toast.error("Nothing to select as all. Please try with indivdual selection.")
        }

      } else {
        tempUserList.user_list = tempUserList.user_list.map((ele) => {
          return {
            ...ele,
            is_selected: false,
          }
        })

        tempCurrentChangeManagerRole = undefined;
        tempCurrentBusinessLine = undefined;
      }
    }
    setUserList(tempUserList);
    setAllSelected(!allSelected);
    setCurrentChangeManagerRole(tempCurrentChangeManagerRole);
    setCurrentBusinessLine(tempCurrentBusinessLine);
    setCurrentBusinessUnitId(tempCurrentBusinessUnitID);
    setCurrentBusinessVerticalId(tempCurrentBusinessVerticalID);
  }

  const handleSelectOne = (k) => {
    let tempUserList = { ...userList };
    if (isIndependentSelectionTab) {
      tempUserList.user_list[k].is_selected = !tempUserList.user_list[k].is_selected;
      setUserList(tempUserList);
      return;
    }
    let tempCurrentChangeManagerRole = currentChangeManagerRole;
    let tempCurrentBusinessLine = currentBusinessLine;
    let tempCurrentBusinessUnitID = currentBusinessUnitId;
    let tempCurrentBusinessVerticalID = currentBusinessVerticalId;
    if (tempCurrentChangeManagerRole) {
      if (!tempUserList.user_list[k].is_selected) {
        if (tempUserList.user_list[k].reporting_to_role) {
          console.log("########", tempUserList.user_list[k].reporting_to_role, tempCurrentChangeManagerRole);
          if (tempUserList.user_list[k].reporting_to_role !== tempCurrentChangeManagerRole) {
            toast.error("Please select only users who have the same reporting to role")
          } else if (tempUserList.user_list[k].business_unit_id !== tempCurrentBusinessUnitID) {
            toast.error("Please select only users who have the same business unit");
          }else if (tempUserList.user_list[k].business_vertical_id !== tempCurrentBusinessVerticalID) {
            toast.error("Please select only users who have the same business vertical");
          }
          // else if (tempUserList.user_list[k].business_line != tempCurrentBusinessLine) {
          //   toast.error("Please select only users who have the same business line")
          // } 
          else if (tempUserList.user_list[k].reporting_to_role === tempCurrentChangeManagerRole /*&& tempUserList.user_list[k].business_line == tempCurrentBusinessLine*/) {
            tempUserList.user_list[k].is_selected = true;
          }
        } else {
          toast.error("Please add reporting to role for particular user before this action.")
        }
      } else {
        tempUserList.user_list[k].is_selected = false;
      }
    } else {
      tempCurrentChangeManagerRole = tempUserList.user_list[k].reporting_to_role || undefined;
      tempCurrentBusinessLine = tempUserList.user_list[k].business_line || undefined;
      tempCurrentBusinessUnitID = tempUserList.user_list[k].business_unit_id || undefined;
      tempCurrentBusinessVerticalID = tempUserList.user_list[k].business_vertical_id || undefined;
      if (!tempUserList.user_list[k].is_selected) {
        if (tempUserList.user_list[k].reporting_to_role) {
          if (tempUserList.user_list[k].reporting_to_role !== tempCurrentChangeManagerRole) {
            toast.error("Please select only users who have the same reporting to role")
          } else if (tempUserList.user_list[k].business_unit_id !== tempCurrentBusinessUnitID) {
            toast.error("Please select only users who have the same business unit");
          } else if (tempUserList.user_list[k].business_vertical_id !== tempCurrentBusinessVerticalID) {
            toast.error("Please select only users who have the same business vertical"); 
          }
          // else if (tempUserList.user_list[k].business_line != tempCurrentBusinessLine) {
          //   toast.error("Please select only users who have the same business line")
          // } 
          else {
            tempUserList.user_list[k].is_selected = true;
          }
        } else {
          toast.error("Please add reporting to role for particular user before this action.")
        }
      } else {
        tempUserList.user_list[k].is_selected = false;
      }
    }
    setUserList(tempUserList);
    setCurrentChangeManagerRole(tempCurrentChangeManagerRole);
    setCurrentBusinessLine(tempCurrentBusinessLine)
    setCurrentBusinessUnitId(tempCurrentBusinessUnitID);
    setCurrentBusinessVerticalId(tempCurrentBusinessVerticalID);
  }

  const hidechangeMappingPopup = () => {
    setChangeMapping(false);
    document.body.classList.remove("overflow-hidden");
    getUserList(userManagementSearch, offset, currentStatus, sortToggle);
  }

  const showChangeMappingPopup = () => {
    let tempUserList = userList?.user_list?.filter(ele => ele.is_selected) || [];
    if (tempUserList.length) {
      setChangeMapping(true);
      document.body.classList.add("overflow-hidden");
    } else {
      toast.error("Please select user.")
    }

  }

  const hidechangeTaggingPopup = () => {
    setChangeTagging(false);
    document.body.classList.remove("overflow-hidden");
    getUserList(userManagementSearch, offset, currentStatus, sortToggle);
  }

  const showChangeTaggingPopup = () => {
    let tempUserList = userList?.user_list?.filter(ele => ele.is_selected) || [];
    if (tempUserList.length) {
      setChangeTagging(true);
      document.body.classList.add("overflow-hidden");
    } else {
      toast.error("Please select user.")
    }
  }

  const hideMarkInactivePopup = () => {
    setMarkInactive(false);
    document.body.classList.remove("overflow-hidden");
    getUserList(userManagementSearch, offset, currentStatus, sortToggle);
  }

  const showMarkInactivePopup = () => {
    let tempUserList = userList?.user_list?.filter(ele => ele.is_selected) || [];
    if (tempUserList.length) {
      setMarkInactive(true);
      document.body.classList.add("overflow-hidden");
    } else {
      toast.error("Please select user.")
    }
  }

  const hideRejectRequestPopup = () => {
    setRejectRequest(false);
    document.body.classList.remove("overflow-hidden");
    getUserList(userManagementSearch, offset, currentStatus, sortToggle);
  }

  const showRejectRequestPopup = () => {
    let tempUserList = userList?.user_list?.filter(ele => ele.is_selected) || [];
    if (tempUserList.length) {
      setRejectRequest(true);
      document.body.classList.add("overflow-hidden");
    } else {
      toast.error("Please select user.");
    }
  }

  const hideRejectRemapRequestPopup = () => {
    setRejectRemapRequest(false);
    document.body.classList.remove("overflow-hidden");
    getUserList(userManagementSearch, offset, currentStatus, sortToggle);
  }

  const showRejectRemapRequestPopup = () => {
    let tempUserList = userList?.user_list?.filter(ele => ele.is_selected) || [];
    if (tempUserList.length) {
      setRejectRemapRequest(true);
      document.body.classList.add("overflow-hidden");
    } else {
      toast.error("Please select user.");
    }
  }

  const hideApproveRemapRequestPopup = () => {
    setApproveRemapRequest(false);
    document.body.classList.remove("overflow-hidden");
    getUserList(userManagementSearch, offset, currentStatus, sortToggle);
  }

  const showApproveRemapRequestPopup = () => {
    let tempUserList = userList?.user_list?.filter(ele => ele.is_selected) || [];
    if (tempUserList.length) {
      setApproveRemapRequest(true);
      document.body.classList.add("overflow-hidden");
    } else {
      toast.error("Please select user.");
    }
  }

  const handleApproveRemapRequest = () => {
    let tempUserList = userList?.user_list?.filter(ele => ele.is_selected) || [];
    if (!tempUserList.length) {
      toast.error("Please select user.");
      return;
    }
    setLoading(true);
    MasterService.post('/sfa/user/approveRemapRequest', { user_ids: tempUserList.map(e => e.id) })
      .then(function (response) {
        setLoading(false);
        if (response.data.status === 200) {
          toast.success(response.data.message);
        } else {
          toast.error(response.data.message);
        }
        hideApproveRemapRequestPopup();
      })
      .catch(function (error) {
        setLoading(false);
        toast.error(error?.response?.data?.message || "Something went wrong");
        hideApproveRemapRequestPopup();
      });
  }

  const OnboardedFrom = [
    { value: 'mobile_app', label: 'App' },
    { value: 'join_us', label: 'Join Us' },
    { value: 'admin', label: 'SFA Backend' },
  ];

  const eSignStatus = [
    { value: '1', label: 'Yes' },
    { value: '0', label: 'No' },

  ];
  const reporteeType = [
    { value: 'direct_reportee', label: 'Direct Reportee' },
    { value: 'all_reportee', label: 'All Reportee' },
  ];
  const statusHandle = () => {
    if (userManagementSearch.inactive_pending_request === 1) {
      inactiveRequestsUserLink.current.click();
    } else if (userManagementSearch.rejected_inactive_request === 1) {
      rejectedInactiveRequestsUserLink.current.click();
    } else if (userManagementSearch.remap_pending_request === 1) {
      remapRequestsUserLink.current.click();
    } else if (userManagementSearch.rejected_remap_request === 1) {
      rejectedRemapRequestsUserLink.current.click();
    } else if (currentStatus.toString() === '0') {
      inActiveUserLink.current.click();
    } else if (currentStatus.toString() === '1') {
      activeUserLink.current.click();
    } else if (currentStatus.toString() === '3') {
      rejectedUserLink.current.click();
    } else if (currentStatus.toString() === '4') {
      inProcessUserLink.current.click();
    } else if (TENANT !== TENANTS.PH && currentStatus.toString() === '5') {
      approvalPendingUserLink.current.click();
    } else if (currentStatus.toString() === '') {
      // allUserLink.current.click();
    }
  }
  const getTaggingList = async (roleIds) => {
    //setLoading(true); 
    MasterService.post('/sfa/user/tagging_list', { 'role_ids': roleIds })
      .then(function (response) {
        //setLoading(false); 
        if (response.data.status === 200) {
          setTaggingOption(response.data.data);
        }
      })
      .catch(function (response) {
        //setLoading(false); 
      });
  }
  const getUserList = async (userManagementSearchTemp, page, status, sortToggle = {}) => {
    delete (userManagementSearchTemp.status);
    setLoading(true);
    MasterService.post('/sfa/user/get-users-list', { 'sort_toggle': sortToggle, 'status': status, 'page_no': page + 1, include_summary: false, ...userManagementSearchTemp })
      .then(function (response) {
        if (response.data.status === 200) {
          setLoading(false);
          setUserList((prev) => ({
            ...response.data.data,
            tab_count_data: TENANT === TENANTS.PH ? response.data.data?.tab_count_data : prev?.tab_count_data || {}
          }));
          if(TENANT === TENANTS.PH && (response.data?.pagination && response.data?.pagination?.total)){
            let tempPageCount = Math.ceil(response.data.pagination.total / 50);
            setPageCount(tempPageCount);
          }
        } else {
          setLoading(false);
        }
      })
      .catch(function (response) {
        setLoading(false);
      });
    if(TENANT !== TENANTS.PH )getUserListSummary(userManagementSearchTemp, status);
  }
  const getUserListSummary = async (userManagementSearchTemp, status) => {
    MasterService.post('/sfa/user/get-users-list-summary', { 'status': status, ...userManagementSearchTemp })
      .then(function (response) {
        if (response.data.status === 200 && response.data.data?.tab_count_data) {
          setUserList((prev) => ({
            ...prev,
            tab_count_data: response.data.data.tab_count_data
          }));
          if (response.data.data.total_pagination_count || response.data.data.total_pagination_count === 0) {
            let tempPageCount = Math.ceil(response.data.data.total_pagination_count / 50);
            setPageCount(tempPageCount);
          }
        }
      })
      .catch(function (response) {
      });
  }
  const getBusinessLineList = async () => {
    MasterService.post('/sfa/user/business_line_list', {})
      .then(function (response) {
        if (response.data.status === 200) {
          SetBusinessLine(response.data.data);
        }
      })
      .catch(function (response) {
      });
  }
  const getSubStatusList = async () => {
    MasterService.post('/sfa/user/sub_status_list', {})
      .then(function (response) {
        if (response.data.status === 200) {
          SetSubStatusOption(response.data.data);
        }
      })
      .catch(function (response) {
      });
  }
  const getAllRoleList = async () => {
    MasterService.post('/sfa/user/role_list', {})
      .then(function (response) {
        if (response.data.status === 200) {
          const arr = response.data.data && response.data.data.length > 0 && response.data.data.filter(i => ![53, 54, 55].includes(i.id))
          SetReportingRole(arr);
          SetAllReportingRole(response.data.data);
        }
      })
      .catch(function (response) {
      });
  }
  const getStateList = async () => {
    MasterService.post('/sfa/user/state_list', { "zone_id": 5 })
      .then(function (response) {
        if (response.data.status === 200) {
          SetStateList(response.data.data);
        }
      })
      .catch(function (response) {
      });
  }
  const handleDpdOptionChange = (sname, oValue) => {
    let statusId = oValue.id;
    var userManagementSearchTemp = { ...userManagementSearch };
    if (oValue == null)
      userManagementSearchTemp[sname] = 0;
    if (sname === 'business_line') {
      userManagementSearchTemp[sname] = oValue.business_line_id;
    } else if (sname === 'esign_status' || sname === 'user_source' || sname === 'reportee_type') {
      userManagementSearchTemp[sname] = oValue.value;
    } else {
      userManagementSearchTemp[sname] = statusId;
    }
    setUserManagementSearch(userManagementSearchTemp);
  }
  const handleRoleOptionChange = (sname, oValue) => {
    let role_id = 0;
    if (typeof oValue == 'number') {
      role_id = oValue;
    } else {
      role_id = oValue.id;
    }
    var userManagementSearchTemp = { ...userManagementSearch };
    if (oValue == null)
      userManagementSearchTemp[sname] = 0;
    else
      userManagementSearchTemp[sname] = role_id;
    setUserManagementSearch(userManagementSearchTemp);
    if (sname === 'reporting_role_id') {
      setReportingToHide(0);
      getRoleUsersList(role_id);
    }
  }
  const getRoleUsersList = (role_id, search_text = "", page_no = 1) => {
    if (!role_id)  return;
    
    reportingManagerQueryRef.current = { role_id, search_text, page_limit: 500 };
    if (page_no > 1)  setReportingManagerLoadingMore(true);
    setDropDownLoaders(prev => ({ ...prev, reporting_manager: true }));


    const vertical_id = userManagementSearch?.vertical_id || undefined;
    MasterService.post('/sfa/user/get-users', { 'role_id': role_id, search_text, page_no, page_limit: 500, ...(vertical_id && { vertical_id }) })
      .then(function (response) {
        if (response.data.status === 200) {
          let reporting_manager_list = response.data.data.user_list || [];
      
        
          const hasNext = response.data.pagination?.hasNext ?? false;
          setReportingManagerHasNext(hasNext);
          setReportingManagerCurrentPage(page_no);


          if (page_no > 1) {
            setReportingManagerLoadingMore(false);
            SetReportingTo(prevList => {
                  const merged = [...prevList, ...reporting_manager_list];
                  const uniqueMap = new Map(merged.map(item => [item.id, item]));
                  return Array.from(uniqueMap.values());
              })
          } else {
            SetReportingTo(reporting_manager_list)
          }
        }

      })
      .catch(function (response) {
        //setLoading(false); 
      }).finally(() => {
        setDropDownLoaders(prev => ({ ...prev, reporting_manager: false }));
      });
  }
  const handleChangeMultiSel = (field_name, field_obj) => {
    // let tempError = {...errors}
    // let isvalid = true
    let currval = [];
    var userManagementSearchTemp = { ...userManagementSearch };
    if (field_name === "state") {
      currval = field_obj.map(v => v.id);
      setStateData(field_obj);
      getCityList(currval);
    }
    if (field_name === "city") {
      currval = field_obj.map(v => v.id);
      setCityData(field_obj);
    }
    if (field_name === "sub_status") {
      currval = field_obj.map(v => v.substatus_value);
      setSubStatusData(field_obj);
    }
    if (field_name === "role_id") {
      currval = field_obj?.map(v => v.id);
      let taggingListOption = getTaggingList(currval);
      if (taggingListOption && Array.isArray(taggingListOption)) {
        setTaggingOption(taggingListOption);
      }
      setRoleData(field_obj);
    }
    if (field_name === "tagging_id") {
      currval = field_obj?.map(v => v.tagging_id);
      setTaggingList(field_obj);
    }
    userManagementSearchTemp[field_name] = currval;
    // if(isvalid){
    setUserManagementSearch(userManagementSearchTemp);
    // } else {
    //   SetErrors(tempError)
    // }
  }
  const getCityList = async (state_ids) => {
    //setLoading(true); 
    SetCityList([]);
    if (state_ids && state_ids.length > 0) {
      MasterService.post('/sfa/user/city_list', { "state_ids": state_ids })
        .then(function (response) {
          //setLoading(false); 
          if (response.data.status === 200) {
            SetCityList(response.data.data);
          }
        })
        .catch(function (response) {
          //setLoading(false); 
        });
    }
  }
  // const getDropdownButtonLabel = ({ placeholderButtonLabel, value }) => {//removed warning
  //   if (value && value.length === 0) {
  //     return `${placeholderButtonLabel}`;
  //   } else if (value && value.length) {
  //     return `${value.length} selected`;
  //   }
  //   else
  //     return `${placeholderButtonLabel}`;
  // }
  const resetMoreFilter = (event) => {
    resetFilterForm(event);
    lessFilterRef.current.click();
  }
  const downloadPHUserData = async () => {
    setLoading(true);
    await MasterService.post('/sfa/user/download_user_list', { 'status': currentStatus, ...userManagementSearch })
      .then(function (response) {
        setLoading(false);
        if (response.data.status === 200) {
          let tempmMappingCsvData = (response.data && response.data.data.user_list) ? response.data.data.user_list : [];
          setUserCsvData(tempmMappingCsvData);
          csvLink.current.link.click();
        }
      })
      .catch(function (response) {
        setLoading(false);
      });


  }
  const resetLessFilter = (event) => {
    resetFilterForm(event);
  }
  const resetFilterForm = event => {
    event.preventDefault();
    setDateRange([null, null]);
    setDateRange1([null, null]);
    setRoleData([]);
    setTaggingList([]);
    setStateData([]);
    setCityData([]);
    setSubStatusData([]);
    setUserManagementSearch({ inactive_pending_request: (userManagementSearch?.inactive_pending_request) ? userManagementSearch.inactive_pending_request : 0, remap_pending_request: 0, rejected_remap_request: 0 });
    setReportingToHide(1);
    SetErrors({});
    setCurrentChangeManagerRole(undefined);
    setCurrentBusinessLine(undefined);
    setCurrentBusinessUnitId(undefined);
    setCurrentBusinessVerticalId(undefined);
    setAllSelected(false);
    setTaggingOption([]);
    let tempUserList = { ...userList };
    if (tempUserList?.user_list?.length) {
      tempUserList.user_list = tempUserList.user_list.map((ele) => {
        return {
          ...ele,
          is_selected: false,
        }
      })
    }
    //setUserList(tempUserList);
    getUserList({ inactive_pending_request: (userManagementSearch?.inactive_pending_request) ? userManagementSearch.inactive_pending_request : 0 }, 0, currentStatus, {});
  }
  const handleSubmitWithoutMoreFilter = (event) => {
    submitFilterForm(event);
  }
  const handleSubmitWithMoreFilter = (event) => {
    submitFilterForm(event);
    lessFilterRef.current.click();
  }

  const handleExport = () => {
    getExportFields()
    document.body.classList.add("overflow-hidden");
  }

  const getExportFields = async () => {
    setLoading(true);
    let temp_export_fields_data = { ...export_field_data }
    await MasterService.post('/sfa/user/get_export_fields', {})
      .then(function (response) {
        setLoading(false);
        if (response.data.status === 200 && response.data.data && response.data.data.export_user_field) {
          setExportFormField(response.data.data.export_user_field)
          setExportOptionModal(true);
          temp_export_fields_data["Forms"] = []
          temp_export_fields_data["Role Details"] = []
          temp_export_fields_data["Basic Details"] = []
          setExportFieldData(temp_export_fields_data)
        }
      })
      .catch(function (response) {
        setLoading(false);
      });
  }

  const hideExportClose = () => {
    setExportOptionModal(false);
    document.body.classList.remove("overflow-hidden");
  }

  const submitFilterForm = event => {
    event.preventDefault();
    setOffset(0);
    if (validateForm()) {
      getUserList(userManagementSearch, 0, currentStatus, sortToggle);
    }
  }
  const validateForm = () => {
    var userManagementSearchTemp = { ...userManagementSearch };
    let formIsValid = true;
    let tempErrors = {};
    if (userManagementSearchTemp["reporting_role_id"]) {
      if (!userManagementSearchTemp["reporting_to"]) {
        tempErrors["reporting_to"] = 'Please apply the filter';
        formIsValid = false;
      }
    }
    SetErrors(tempErrors);
    return formIsValid;
  }
  const handledate = (datefield, date) => {
    var userManagementSearchTemp = { ...userManagementSearch };
    if (datefield === 'created_date') {
      setDateRange(date);
      if (date != null) {
        if (date && date.length > 0) {
          if (date[0]) {
            userManagementSearchTemp['start_created_date'] = new Date(date[0]);
          }
          if (date[1]) {
            userManagementSearchTemp['end_created_date'] = new Date(date[1]);
          }
        }
      }
    } else if (datefield === 'approved_date') {
      setDateRange1(date);
      if (date != null) {
        if (date && date.length > 0) {
          if (date[0]) {
            userManagementSearchTemp['start_approved_date'] = new Date(date[0]);
          }
          if (date[1]) {
            userManagementSearchTemp['end_approved_date'] = new Date(date[1]);
          }
        }
      }
    }
    setUserManagementSearch(userManagementSearchTemp);
  }

  const handlePageClick = (e) => {
    const selectedPage = e.selected;
    var userManagementSearchTemp = { ...userManagementSearch };
    setUserManagementSearch(userManagementSearchTemp);
    setOffset(selectedPage);
    getUserList(userManagementSearchTemp, selectedPage, currentStatus, sortToggle);
    setAllSelected(false);
  };
  const tabStatusFilterForm = status_id => {
    setOffset(0);
    setCurrentStatus(status_id);
    var userManagementSearchTemp = { ...userManagementSearch };
    userManagementSearchTemp.status = status_id;
    userManagementSearchTemp.inactive_pending_request = 0;
    userManagementSearchTemp.rejected_inactive_request = 0;
    userManagementSearchTemp.remap_pending_request = 0;
    userManagementSearchTemp.rejected_remap_request = 0;
    setUserManagementSearch(userManagementSearchTemp);
    getUserList(userManagementSearchTemp, 0, status_id, sortToggle);
  };
  const tabInactiveRequestFilterForm = () => {
    setOffset(0);
    setCurrentStatus("1");
    var userManagementSearchTemp = { ...userManagementSearch };
    userManagementSearchTemp.inactive_pending_request = 1;
    userManagementSearchTemp.rejected_inactive_request = 0;
    userManagementSearchTemp.remap_pending_request = 0;
    userManagementSearchTemp.rejected_remap_request = 0;
    setUserManagementSearch(userManagementSearchTemp);
    getUserList(userManagementSearchTemp, 0, currentStatus, sortToggle);
  };

  const tabRejectedInactiveRequestFilterForm = () => {
    setOffset(0);
    setCurrentStatus("");
    var userManagementSearchTemp = { ...userManagementSearch };
    userManagementSearchTemp.inactive_pending_request = 0;
    userManagementSearchTemp.rejected_inactive_request = 1;
    userManagementSearchTemp.remap_pending_request = 0;
    userManagementSearchTemp.rejected_remap_request = 0;
    setUserManagementSearch(userManagementSearchTemp);
    getUserList(userManagementSearchTemp, 0, "", sortToggle);
  };

  const tabRemapRequestFilterForm = () => {
    setOffset(0);
    setCurrentStatus("1");
    var userManagementSearchTemp = { ...userManagementSearch };
    userManagementSearchTemp.remap_pending_request = 1;
    userManagementSearchTemp.rejected_remap_request = 0;
    userManagementSearchTemp.inactive_pending_request = 0;
    userManagementSearchTemp.rejected_inactive_request = 0;
    setUserManagementSearch(userManagementSearchTemp);
    getUserList(userManagementSearchTemp, 0, currentStatus, sortToggle);
  };

  const tabRejectedRemapRequestFilterForm = () => {
    setOffset(0);
    setCurrentStatus("");
    var userManagementSearchTemp = { ...userManagementSearch };
    userManagementSearchTemp.remap_pending_request = 0;
    userManagementSearchTemp.rejected_remap_request = 1;
    userManagementSearchTemp.inactive_pending_request = 0;
    userManagementSearchTemp.rejected_inactive_request = 0;
    setUserManagementSearch(userManagementSearchTemp);
    getUserList(userManagementSearchTemp, 0, "", sortToggle);
  };
  const getClassName = (statusId) => {
    let statusClass = '';
    if (statusId === "0") {
      statusClass = 'status-inactive';
    } else if (statusId === "1") {
      statusClass = 'status-active';
    } else if (statusId === "2") {
      statusClass = 'status-inactive';
    } else if (statusId === "3") {
      statusClass = 'status-inprocess nowrap';
    } else if (statusId === "4") {
      statusClass = 'status-inprocess nowrap';
    }
    return statusClass;
  }
  const downloadUserData = async (export_type) => {
    setLoading(true);
    let logged_user_id = ''
    let logged_data = ls.get('logged_data')
    if (logged_data && logged_data.token && logged_data.user_data && logged_data.user_data.user_id) {
      logged_user_id = logged_data.user_data.user_id
    }
    let user_count = 0
    if (userList.tab_count_data) {
      switch (parseInt(currentStatus)) {
        case 1:
          user_count = userList.tab_count_data.active_user_count
          break;
        case 5:
          user_count = userList.tab_count_data.approval_pending_user_count
          break;
        case 4:
          user_count = userList.tab_count_data.inprocess_user_count
          break;
        case 0:
          user_count = userList.tab_count_data.inactive_user_count
          break;
        case 3:
          user_count = userList.tab_count_data.rejected_user_count
          break;
        default:
          user_count = userList.tab_count_data.total_user
          break;
      }
    }
    let temp_export_fields_data = { ...export_field_data }
    temp_export_fields_data["Forms"] = temp_export_fields_data["Forms"].filter(e => e.field_name !== "*").map(e => e.field_name)
    temp_export_fields_data["Role Details"] = temp_export_fields_data["Role Details"].filter(e => e.field_name !== "*").map(e => e.field_name)
    temp_export_fields_data["Basic Details"] = temp_export_fields_data["Basic Details"].filter(e => e.field_name !== "*").map(e => e.field_name)
    let call_api = true
    if (export_type === "email") {
      if (temp_export_fields_data["Role Details"].includes("primary_hierarchy") || temp_export_fields_data["Role Details"].includes("secondary_hierarchy")) {
        call_api = false
        toast.error("Primary Hierarchy not valid option for Email Export")
      }
    }
    if (call_api) {
      await MasterService.post('/sfa/user/exportUserData', { export_fields: temp_export_fields_data, user_count, logged_user_id, export_type, 'status': currentStatus, ...userManagementSearch })
        .then(function (response) {
          setLoading(false);
          if (response.data.status === 200) {
            if (export_type === "email") {
              toast.success("Requested data will be shared over the mail shortly!")
            } else {
              let tempmMappingCsvData = (response.data && response.data.data.user_list) ? response.data.data.user_list : [];
              setUserCsvData(tempmMappingCsvData);
              csvLink.current.link.click();
              toast.success("Success")
            }
          } else {
            if (response.data.message) {
              toast.error(response.data.message)
            }
          }
        })
        .catch(function (response) {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }
  const esignApproveSignature = async (signature_status, user_id) => {
    setLoading(true);
    await MasterService.post('/sfa/user/approve_user_signature', { signature_status: signature_status, user_id: user_id })
      .then(function (response) {
        setLoading(false);
        if (response.data.status === 200) {
          toast.success("Success")
          hideModalApproveEsign();
          var userManagementSearchTemp = { ...userManagementSearch };
          getUserList(userManagementSearchTemp, offset, currentStatus, sortToggle);
        } else {
          if (response.data.message) {
            toast.error(response.data.message)
          }
        }
      })
      .catch(function (response) {
        setLoading(false);
      });
  }

  const handleChangetext = event => {
    const { name, value } = event.target;

    const sanitizedValue = value
      .replace(/[^\w\s@.]/gi, "")
      .replace("_", "");

    const updatedSearch = {
      ...userManagementSearch,
      [name]: sanitizedValue,
    };

    setUserManagementSearch(updatedSearch);
    debouncedGetUserList(updatedSearch, 0, currentStatus, sortToggle);
  };


  const showModalUserHistoryPopup = async (userId, role_id) => {
    setLoading(true);
    setActiveRoleId(role_id)
    await MasterService.post('/sfa/user/user_history_list', { 'user_id': userId })
      .then(function (response) {
        setLoading(false);
        if (response.data.status === 200) {
          let tempRoleHistoryList = (response.data && response.data.data && response.data.data.role_history) ? response.data.data.role_history : [];
          let tempAccountHistoryList = (response.data && response.data.data && response.data.data.account_history) ? response.data.data.account_history : [];
          let tempVendorHistoryList = (response.data && response.data.data && response.data.data.vendor_history) ? response.data.data.vendor_history : [];
          let tempProgressionHistoryList = (response.data && response.data.data && response.data.data.progression_history) ? response.data.data.progression_history : [];
          let tempBMGradingHistoryList = (response.data && response.data.data && response.data.data.bm_grading_history) ? response.data.data.bm_grading_history : [];
          let tempAppUsageList = (response.data && response.data.data && response.data.data.app_usage_history) ? response.data.data.app_usage_history : [];
          setUserRoleHistoryList(tempRoleHistoryList);
          setUserAccountHistoryList(tempAccountHistoryList);
          setVendorHistoryList(tempVendorHistoryList);
          setProgressionHistoryList(tempProgressionHistoryList)
          setBMGradingHistoryList(tempBMGradingHistoryList)
          setAppUsageList(tempAppUsageList)
          SetUserHistoryPopup(true);
          document.body.classList.add("overflow-hidden");
        }
      })
      .catch(function (response) {
        setLoading(false);
      });

  }
  const showModalApproveEsign = async (userId) => {
    setLoading(true);
    await MasterService.post('/sfa/user/user_signature_details', { 'user_id': userId })
      .then(function (response) {
        setLoading(false);
        if (response.data.status === 200) {
          let tempSignatureData = (response.data && response.data.data) ? response.data.data : [];
          setSignatureData(tempSignatureData);
          SetEsignApproveUserPopup(true);
          document.body.classList.add("overflow-hidden");
        }
      })
      .catch(function (response) {
        setLoading(false);
      });

  }
  const hideModalApproveEsign = () => {
    SetEsignApproveUserPopup(false);
    document.body.classList.remove("overflow-hidden");
  }
  const hideModalUserHistoryPopup = () => {
    SetUserHistoryPopup(false);
    document.body.classList.remove("overflow-hidden");
  }
  const forceLogout = async (userId) => {
    setLoading(true);
    await MasterService.post('/sfa/user/force_user_logout', { 'user_id': userId })
      .then(function (response) {
        setLoading(false);
        if (response.data.status === 200) {
          toast.success(response.data.message);
          var userManagementSearchTemp = { ...userManagementSearch };
          getUserList(userManagementSearchTemp, offset, currentStatus, sortToggle);
        }
      })
      .catch(function (response) {
        setLoading(false);
      });
  }



  const handleView = async (user_id) => {
    //historyLead.push('/view-user/' + user_id)
    window.open('/view-user/' + user_id, '_blank')
  }
  const toggleSort = (currentSortKey) => {
    let tempSortToggle = { ...sortToggle };
    tempSortToggle.currentToggle = currentSortKey;
    if (currentSortKey === 'user_name') {
      tempSortToggle.user_name = !tempSortToggle.user_name;
      tempSortToggle.reporting_role_name = false;
      tempSortToggle.reporting_user_name = false;
      tempSortToggle.created_date = false;
    } else if (currentSortKey === 'reporting_role_name') {
      tempSortToggle.reporting_role_name = !tempSortToggle.reporting_role_name;
      tempSortToggle.user_name = false;
      tempSortToggle.reporting_user_name = false;
      tempSortToggle.created_date = false;

    } else if (currentSortKey === 'reporting_user_name') {
      tempSortToggle.reporting_user_name = !tempSortToggle.reporting_user_name;
      tempSortToggle.user_name = false;
      tempSortToggle.reporting_role_name = false;
      tempSortToggle.created_date = false;
    } else if (currentSortKey === 'created_date') {
      tempSortToggle.created_date = !tempSortToggle.created_date;
      tempSortToggle.user_name = false;
      tempSortToggle.reporting_role_name = false;
      tempSortToggle.reporting_user_name = false;
    }
    setSortToggle(tempSortToggle);
    getUserList(userManagementSearch, offset, currentStatus, tempSortToggle);
  }
  const handleAdd = async () => {
    historyLead('/add-user/role_details')
  }

  //  const toggleTip = (id, state) => {//removed warning
  //    if (state === 'close') {
  //      setTipOpen(false)
  //      id = ''
  //    } else {
  //      setTipOpen(true)
  //    }
  //    setTipOpenId(id)
  //  }

  //  const handleClickAway = () => {//removed warning
  //    toggleTip('', 'close')
  //  }

  const restrictAgentEditing = (userRoleId) => {
    return editAgentRight && (
      adminRoleId !== ADMIN_ROLES['sales_support'] ||
      !(adminRoleId === ADMIN_ROLES['sales_support'] && userRoleId === Role['Agent'] && ["4", ""].includes(currentStatus))
    );
  };

  const handleChangeExportField = (field_name, field_obj, event) => {
    let temp_export_fields_data = { ...export_field_data }
    let selected_value = []
    if (event.action === "select-option" && event.option.field_name === "*") {
      selected_value = exportFormField[field_name].length > 0 ? [{ field_label: "Select All", field_name: "*" }, ...exportFormField[field_name]] : []
    } else if (event.action === "deselect-option" && event.option.field_name === "*") {
      selected_value = []
    } else if (event.action === "deselect-option" && event.option.field_name !== "*") {
      selected_value = field_obj.filter((o) => o.field_name !== "*")
    } else if (field_obj.length > 0 && field_obj.length === exportFormField[field_name].length && exportFormField[field_name].length > 0) {
      selected_value = [{ field_label: "Select All", field_name: "*" }, ...exportFormField[field_name]]
    } else {
      selected_value = field_obj
    }
    temp_export_fields_data[field_name] = selected_value
    setExportFieldData(temp_export_fields_data)
  }

   const handleReportingToInputChange = (inputValue, actionMeta) => {
      if(TENANT === TENANTS.PH) return inputValue;
      if (actionMeta?.action !== 'input-change') return inputValue;
      const role_id = userManagementSearch?.reporting_role_id;
      if (!role_id) return inputValue;
      debouncedGetUsers(role_id, String(inputValue || ""))
      return inputValue;
    }

    const handleReportingManagerMenuScrollToBottom = () => {
        if (!reportingManagerHasNext || reportingManagerLoadingMore) return;
        const { role_id, search_text } = reportingManagerQueryRef.current;
        if (!role_id) return;
        getRoleUsersList(role_id, search_text, reportingManagerCurrentPage + 1)
    };

  return (
    <React.Fragment>
      {loading ? <Loader /> : null}
      <div className="container-fluid">
        <div className="top-heading d-flex">
          <h1>User Management</h1>
          <div className="right-btn">
            {/* <button className="btn-line m-xs-l" disabled> <i className="ic-upload"></i> Bulk Upload</button> */}
            <WithRights rightKey="create_user">
              <button onClick={() => handleAdd()} className="btn-line m-xs-l">Add user</button>
            </WithRights>
          </div>
        </div>
        <div className="loan-filter-bg">
          <div className="top-filter-bg user-management-fiter">
            <form>
              <div className="lead-list-filter">

                <div className="filter-filed-form user-filter-list">

                  <fieldset className="rangepicker-calendra">
                    <div className="material">
                      <div className="datepicker">
                        <DatePicker
                          name="created_date"
                          id="created_date"
                          selectsRange={true}
                          startDate={startDate}
                          endDate={endDate}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          dateFormat="yyyy-MM-dd"
                          onChange={handledate.bind(this, 'created_date')}
                          isClearable={false}
                          placeholderText={(!startDate) ? "Created Date" : ''}
                          autoComplete="off"
                          maxDate={new Date()}
                        />
                        {(startDate) ? <label data-label="Created Date" className="form-label date-label"></label> : ''}
                      </div>
                    </div>
                  </fieldset>
                  <fieldset className="rangepicker-calendra">
                    <div className="material">
                      <div className="datepicker">
                        <DatePicker
                          name="approved_date"
                          id="approved_date"
                          selectsRange={true}
                          startDate={startDate1}
                          endDate={endDate1}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          dateFormat="yyyy-MM-dd"
                          onChange={handledate.bind(this, 'approved_date')}
                          isClearable={false}
                          placeholderText={(!startDate1) ? "Approval Date" : ''}
                          autoComplete="off"
                          maxDate={new Date()}
                        />
                        {(startDate1) ? <label data-label="Approval Date" className="form-label date-label"></label> : ''}
                      </div>
                    </div>
                  </fieldset>
                  <fieldset className="single-select">
                    <div className="material">
                      <Select
                        components={{ ValueContainer: CustomValueContainer }}
                        // components={{ IndicatorSeparator:() => null }}
                        id="user_source"
                        name="user_source"
                        onChange={handleDpdOptionChange.bind(this, 'user_source')}
                        value={OnboardedFrom.filter(({ value }) => value === userManagementSearch.user_source)}
                        options={OnboardedFrom}
                        placeholder="Onboarded From"
                        className="react-select cursor-pointer"
                        classNamePrefix="react-select"
                        isSearchable={false}
                      />
                    </div>
                  </fieldset>
                  <fieldset className="multiselect-dropDown">
                    <div className="material">
                      <ReactMultiSelectCheckboxes
                        options={AllReportingRole}
                        value={RoleData}
                        onChange={handleChangeMultiSel.bind(this, "role_id")}
                        name="role"
                        placeholder="Role"
                        isDisabled={false}
                        isClearable={true}
                        getOptionLabel={({ name }) => name}
                        getOptionValue={({ id }) => id}
                      />
                      {(RoleData && RoleData.length > 0) ? <label data-label="Role" className="form-label date-label"></label> : ''}
                    </div>
                  </fieldset>

                  <fieldset className="single-select">
                    <div className="material">
                      <Select
                        components={{ ValueContainer: CustomValueContainer }}
                        // components={{ IndicatorSeparator:() => null }}
                        id="esign_status"
                        name="esign_status"
                        onChange={handleDpdOptionChange.bind(this, 'esign_status')}
                        options={eSignStatus}
                        value={eSignStatus.filter(({ value }) => value === userManagementSearch.esign_status)}
                        placeholder="eSign Status"
                        className="react-select cursor-pointer"
                        classNamePrefix="react-select"
                        isSearchable={false}
                      />
                    </div>
                  </fieldset>
                  <fieldset className="single-select">
                    <div className="material">
                      <Select
                        components={{ ValueContainer: CustomValueContainer }}
                        // components={{ IndicatorSeparator:() => null }}
                        id="business_unit_id"
                        name="business_unit_id"
                        onChange={handleDpdOptionChange.bind(this, 'business_unit_id')}
                        options={Business}
                        value={Business.filter(e => e.id === userManagementSearch.business_unit_id)}
                        placeholder="Business Unit"
                        className="react-select cursor-pointer"
                        classNamePrefix="react-select"
                        isSearchable={false}
                      />
                    </div>
                  </fieldset>
                  <fieldset className="single-select">
                    <div className="material">
                      <Select
                        components={{ ValueContainer: CustomValueContainer }}
                        // components={{ IndicatorSeparator:() => null }}
                        id="vertical_id"
                        name="vertical_id"
                        onChange={handleDpdOptionChange.bind(this, 'vertical_id')}
                        options={Vertical}
                        value={Vertical.filter(e => e.id === userManagementSearch.vertical_id)}
                        placeholder="Business Vertical"
                        className="react-select cursor-pointer"
                        classNamePrefix="react-select"
                        isSearchable={false}
                      />
                    </div>
                  </fieldset>
                  <div className="more-filter">
                    <div className="filter-option">
                      <Dropdown>
                        <div className="text-btn d-flex">
                          <Dropdown.Toggle variant="success" id="dropdown-basic">

                            <span className="more-filter-txt cursor-pointer">More Filters</span>
                            <span ref={lessFilterRef} className="leass-filter-txt cursor-pointer">Less Filters</span>
                          </Dropdown.Toggle>

                          <div className="btn-submit-reset top-btn-none">
                            <button onClick={handleSubmitWithoutMoreFilter} type='submit' className="btn-primary">Search</button>
                            <button onClick={resetLessFilter} className="btn-reset cursor-pointer">Reset</button>
                          </div>
                        </div>
                        <Dropdown.Menu>
                          <div className="more-filter-option">
                            <h3>More Filters</h3>
                            <div className="filter-form">



                              <fieldset className="single-select">
                                <div className="material">
                                  <Select
                                    components={{ ValueContainer: CustomValueContainer }}
                                    // components={{ IndicatorSeparator: () => null }}
                                    id="reporting_role_id"
                                    name="reporting_role_id"
                                    onChange={handleRoleOptionChange.bind(this, 'reporting_role_id')}
                                    options={ReportingRole}
                                    value={ReportingRole.filter(({ id }) => id === userManagementSearch.reporting_role_id)}
                                    getOptionLabel={({ name }) => name}
                                    getOptionValue={({ id }) => id}
                                    placeholder="Primary Reporting to Role"
                                    className="react-select"
                                    classNamePrefix="react-select"
                                    isSearchable={false}
                                  />
                                </div>
                              </fieldset>

                              <fieldset className="single-select">
                                <div className="material">
                                  <Select
                                    components={{ ValueContainer: CustomValueContainer, MenuList: ReportingManagerMenuList  }}
                                    // components={{ IndicatorSeparator: () => null }}
                                    id="reporting_to"
                                    name="reporting_to"
                                    onChange={handleDpdOptionChange.bind(this, 'reporting_to')}
                                    options={ReportingTo}
                                    value={ReportingTo.filter(({ id }) => id === userManagementSearch.reporting_to)}
                                    onInputChange={handleReportingToInputChange}
                                    getOptionLabel={({ name }) => name}
                                    getOptionValue={({ id }) => id}
                                    placeholder="Primary Reporting To"
                                    className="react-select"
                                    classNamePrefix="react-select"
                                    isSearchable={true}
                                    isDisabled={(reportingToHide === 1) ? true : false}

                                    isLoading={dropDownLoaders.reporting_manager}
                                    loadingMessage={() => <span>Loading...</span>}
                                    onLoadMore={handleReportingManagerMenuScrollToBottom}
                                    isLoadingMore={reportingManagerLoadingMore}
                                  />
                                  {
                                    (errors && errors.reporting_to) ? <span className="error show">{errors.reporting_to}</span> : ''
                                  }
                                </div>
                              </fieldset>
                              <fieldset className="single-select">
                                <div className="material">
                                  <Select
                                    components={{ ValueContainer: CustomValueContainer }}
                                    // components={{ IndicatorSeparator: () => null }}
                                    id="reportee_type"
                                    name="reportee_type"
                                    onChange={handleDpdOptionChange.bind(this, 'reportee_type')}
                                    options={reporteeType}
                                    value={reporteeType.filter(({ value }) => value === userManagementSearch.reportee_type)}
                                    placeholder="Reportee Type"
                                    className="react-select"
                                    classNamePrefix="react-select"
                                    isSearchable={false}
                                    isDisabled={!(userManagementSearch.reporting_role_id && userManagementSearch.reporting_to)}
                                  />
                                </div>
                              </fieldset>
                              <fieldset className="multiselect-dropDown">
                                <div className="material">
                                  {/* <ReactMultiSelectCheckboxes
                                      isMulti
                                      options={TaggingOption}
                                      placeholderButtonLabel="Tagging"                                     
                                      iconAfter="false"
                                      className="react-select"
                                      classNamePrefix="react-select"
                                      getDropdownButtonLabel={getDropdownButtonLabel}
                                      value={TaggingList}
                                      isSearchable={false}
                                      onChange={handleChangeMultiSel.bind(this, "tagging_id")}
                                      getOptionLabel={({ tagging_name }) => tagging_name}
                                      getOptionValue={({ tagging_id }) => tagging_id}
                                      // isDisabled = {RoleData?.map(ele=>ele.id).includes(Role.Agent || Role.ARO || Role.BRO) ? false : true}
                                    /> */}
                                  <ReactMultiSelectCheckboxes
                                    options={TaggingOption}
                                    value={TaggingList}
                                    onChange={handleChangeMultiSel.bind(this, "tagging_id")}
                                    name="tagging"
                                    placeholder="Tagging"
                                    isDisabled={false}
                                    isClearable={true}
                                    getOptionLabel={({ tagging_name }) => tagging_name}
                                    getOptionValue={({ tagging_id }) => tagging_id}
                                  />
                                  {(TaggingList && TaggingList.length > 0) ? <label data-label="Tagging" className="form-label date-label"></label> : ''}
                                </div>
                              </fieldset>
                              <fieldset class="multiselect-dropDown">
                                <div class="material">
                                  {/* <ReactMultiSelectCheckboxes
                                      isMulti
                                      options={StateList}
                                      placeholderButtonLabel="State"
                                      iconAfter="false"
                                      getDropdownButtonLabel={getDropdownButtonLabel}
                                      value={StateData}
                                      onChange={handleChangeMultiSel.bind(this, "state")}
                                      getOptionLabel={({ state_name }) => state_name}
                                      getOptionValue={({ id }) => id}
                                    /> */}
                                  <ReactMultiSelectCheckboxes
                                    options={StateList}
                                    value={StateData}
                                    onChange={handleChangeMultiSel.bind(this, "state")}
                                    name="state"
                                    placeholder="State"
                                    isDisabled={false}
                                    isClearable={true}
                                    getOptionLabel={({ state_name }) => state_name}
                                    getOptionValue={({ id }) => id}
                                  />
                                  {(StateData && StateData.length > 0) ? <label data-label="State" className="form-label date-label"></label> : ''}
                                </div>
                              </fieldset>

                              <fieldset class="multiselect-dropDown">
                                <div class="material">
                                  {/* <ReactMultiSelectCheckboxes
                                      isMulti
                                      options={CityList}
                                      placeholderButtonLabel="City"
                                      iconAfter="false"
                                      getDropdownButtonLabel={getDropdownButtonLabel}
                                      value={CityData}
                                      onChange={handleChangeMultiSel.bind(this, "city")}
                                      getOptionLabel={({ city_name }) => city_name}
                                      getOptionValue={({ id }) => id}
                                    /> */}
                                  <ReactMultiSelectCheckboxes
                                    options={CityList}
                                    value={CityData}
                                    onChange={handleChangeMultiSel.bind(this, "city")}
                                    name="city"
                                    placeholder="City"
                                    isDisabled={false}
                                    isClearable={true}
                                    getOptionLabel={({ city_name }) => city_name}
                                    getOptionValue={({ id }) => id}
                                  />
                                  {(CityData && CityData.length > 0) ? <label data-label="City" className="form-label date-label"></label> : ''}
                                </div>
                              </fieldset>


                              <fieldset className="single-select">
                                <div className="material">
                                  <Select
                                    components={{ ValueContainer: CustomValueContainer }}
                                    // components={{ IndicatorSeparator: () => null }}
                                    id="business_line"
                                    name="business_line"
                                    onChange={handleDpdOptionChange.bind(this, 'business_line')}
                                    options={BusinessLine}
                                    value={BusinessLine.filter(({ business_line_id }) => business_line_id === userManagementSearch.business_line)}
                                    getOptionLabel={({ business_line }) => business_line}
                                    getOptionValue={({ business_line_id }) => business_line_id}
                                    placeholder="Sales Team"
                                    className="react-select"
                                    isSearchable={false}
                                    classNamePrefix="react-select"
                                  />
                                </div>
                              </fieldset>

                              {((TENANT === TENANTS.OTO || TENANT === TENANTS.TRIV) ? RoleData?.map(ele => ele.id).includes(Role.Agent) : (RoleData?.map(ele => ele.id).includes(Role.FA))) ?
                                <fieldset class="multiselect-dropDown">
                                  <div class="material">                                 
                                    <ReactMultiSelectCheckboxes
                                      options={SubStatusOption}
                                      value={SubStatusData}
                                      onChange={handleChangeMultiSel.bind(this, "sub_status")}
                                      name="sub_status"
                                      placeholder="Sub Status"
                                      isDisabled={false}
                                      isClearable={true}
                                      getOptionLabel={({ substatus_label }) => substatus_label}
                                      getOptionValue={({ id }) => id}
                                    />
                                    {(SubStatusData && SubStatusData.length > 0) ? <label data-label="Sub Status" className="form-label date-label"></label> : ''}
                                  </div>
                                </fieldset> : ""}

                            </div>
                            <div className="btn-submit-reset more-filter-btn p-sm-t">
                              <button onClick={handleSubmitWithMoreFilter} type='submit' className="btn-primary">Search</button>
                              <button onClick={resetMoreFilter} className="btn-reset cursor-pointer">Reset</button>
                            </div>

                          </div>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="user-action-btn">
            <h2>Users</h2>
            <div className="right-btn">
              {userManagementSearch.inactive_pending_request === 1 &&
                <WithRights rightKey="update_user_mapping">
                  <button className="btn-line" onClick={showRejectRequestPopup} disabled={!isAnyUserSelected}>Reject Inactive Request</button>
                </WithRights>
              }
              {userManagementSearch.remap_pending_request === 1 &&
                <WithRights rightKey="update_user_mapping">
                  <button className="btn-line" onClick={showRejectRemapRequestPopup} disabled={!isAnyUserSelected}>Reject Request</button>
                  <button className="btn-line" onClick={showApproveRemapRequestPopup} disabled={!isAnyUserSelected}>Approve Request</button>
                </WithRights>
              }
              {(userManagementSearch.inactive_pending_request === 1 || (userManagementSearch.reporting_to && RoleData?.length === 1 && RoleData[0]?.id === Role.Agent)) &&
                <WithRights rightKey="update_user_mapping">
                  <button className="btn-line" onClick={showMarkInactivePopup} disabled={!isAnyUserSelected || !['1'].includes(currentStatus)}>Mark Inactive</button>
                </WithRights>
              }
              {(userManagementSearch.inactive_pending_request !== 1 && userManagementSearch.reporting_to && RoleData?.length === 1 && RoleData[0]?.id === Role.Agent) &&
                <WithRights rightKey="update_user_mapping">
                  <button className="btn-line" onClick={showChangeTaggingPopup} disabled={!isAnyUserSelected || !['1'].includes(currentStatus)}>Change Tagging</button>
                </WithRights>
              }
              {(['1'].includes(currentStatus)
                && userManagementSearch.inactive_pending_request !== 1
                && userManagementSearch.remap_pending_request !== 1
                && !userManagementSearch.rejected_inactive_request
                && !userManagementSearch.rejected_remap_request) &&
                <WithRights rightKey="update_user_mapping">
                  <button className="btn-line" onClick={showChangeMappingPopup} disabled={!isAnyUserSelected}>Change Reporting</button>
                </WithRights>
              }
              {(userManagementSearch.inactive_pending_request !== 1
                && userManagementSearch.remap_pending_request !== 1
                && !userManagementSearch.rejected_inactive_request
                && !userManagementSearch.rejected_remap_request) && <WithRights rightKey="export_data">
                <button onClick={TENANT === TENANTS.PH ? downloadPHUserData : handleExport} disabled={userList && userList.user_list && userList.user_list.length === 0 ? true : false} className="btn-line">
                  <i class="ic-export m-xs-r"></i>
                  <span>Export Data</span>
                </button>
                <CSVLink
                  data={userCsvData}
                  filename={`user-list-${Math.round(+new Date() / 1000)}.csv`}
                  data-interception='off'
                  ref={csvLink}
                >
                </CSVLink>
              </WithRights>
              }
            </div>
          </div>
          <div className="user-management-detail-tab-outer">
            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
              <div className="user-managemnt-detail-tabs">
                <Nav variant="pills" className="flex-column tab-line">
                  <div className="tab-list">
                    <WithRights rightKey="total_bucket">
                      <Nav.Item onClick={() => tabStatusFilterForm("")} ref={allUserLink}>
                        <Nav.Link eventKey="first">All Users ({userList.tab_count_data && userList.tab_count_data.total_user})  </Nav.Link>
                      </Nav.Item>
                    </WithRights>
                    <WithRights rightKey="active_bucket">
                      <Nav.Item onClick={() => tabStatusFilterForm("1")}>
                        <Nav.Link eventKey="second" ref={activeUserLink}> Active Users ({userList.tab_count_data && userList.tab_count_data.active_user_count})</Nav.Link>
                      </Nav.Item>
                    </WithRights>
                    <WithRights rightKey="approval_pending_bucket">
                      {TENANT !== TENANTS.PH && <Nav.Item onClick={() => tabStatusFilterForm("5")}>
                        <Nav.Link eventKey="sixth" ref={approvalPendingUserLink}>Approval Pending Users ({userList.tab_count_data && userList.tab_count_data.approval_pending_user_count})</Nav.Link>
                      </Nav.Item>}
                    </WithRights>
                    <WithRights rightKey="in_progress_bucket">
                      <Nav.Item onClick={() => tabStatusFilterForm("4")}>
                        <Nav.Link eventKey="fourth" ref={inProcessUserLink}>In Progress Users ({userList.tab_count_data && userList.tab_count_data.inprocess_user_count})</Nav.Link>
                      </Nav.Item>
                    </WithRights>
                    <WithRights rightKey="inactive_bucket">
                      <Nav.Item onClick={() => tabStatusFilterForm("0")}>
                        <Nav.Link eventKey="third" ref={inActiveUserLink}>Inactive Users ({userList.tab_count_data && userList.tab_count_data.inactive_user_count})</Nav.Link>
                      </Nav.Item>
                    </WithRights>
                    <WithRights rightKey="rejected_bucket">
                      <Nav.Item onClick={() => tabStatusFilterForm("3")}>
                        <Nav.Link eventKey="fifth" ref={rejectedUserLink}>Rejected Users ({userList.tab_count_data && userList.tab_count_data.rejected_user_count})</Nav.Link>
                      </Nav.Item>
                    </WithRights>
                    {(TENANT !== TENANTS.PH) && <Nav.Item onClick={() => tabInactiveRequestFilterForm()}>
                      <Nav.Link eventKey="seventh" ref={inactiveRequestsUserLink}>Inactive Requests ({userList.tab_count_data && userList.tab_count_data.inactive_user_request_count})</Nav.Link>
                    </Nav.Item>}
                    {(TENANT !== TENANTS.PH) && <Nav.Item onClick={() => tabRejectedInactiveRequestFilterForm()}>
                      <Nav.Link eventKey="eighth" ref={rejectedInactiveRequestsUserLink}>Rejected Inactive Requests ({userList.tab_count_data && userList.tab_count_data.rejected_inactive_request_count})</Nav.Link>
                    </Nav.Item>}
                    {(TENANT !== TENANTS.PH) && <Nav.Item onClick={() => tabRemapRequestFilterForm()}>
                      <Nav.Link eventKey="ninth" ref={remapRequestsUserLink}>Remap Requests ({userList.tab_count_data ? (userList.tab_count_data.remap_request_count || 0) : 0})</Nav.Link>
                    </Nav.Item>}
                    {(TENANT !== TENANTS.PH) && <Nav.Item onClick={() => tabRejectedRemapRequestFilterForm()}>
                      <Nav.Link eventKey="tenth" ref={rejectedRemapRequestsUserLink}>Rejected Remap Requests ({userList.tab_count_data ? (userList.tab_count_data.rejected_remap_request_count || 0) : 0})</Nav.Link>
                    </Nav.Item>}
                  </div>
                </Nav>
                <fieldset className="search-bx">
                  <div class="material">
                    <InputField
                      id="search_by"
                      type="text"
                      placeholder="Search By Name,SFA ID,Mobile No,Email"
                      name="search_by"
                      autoComplete="off"
                      value={
                        userManagementSearch &&
                          userManagementSearch.search_by
                          ? userManagementSearch.search_by
                          : ""
                      }
                      label="Search"
                      onChange={handleChangetext}
                    />
                    <i className="ic-search"></i>
                  </div>
                </fieldset>
              </div>
              <div className={`user-managemnt-detail-table data-table${currentStatus === REJECT_STATUS ? ' rejected_data_table' : ''}${userManagementSearch.rejected_remap_request === 1 ? ' remap_rejected_data_table' : ''}`}>
                <table>
                  <thead>
                    <tr>
                      <WithRights rightKey="update_user_mapping" fallback={<th style={{ width: '2px' }}></th>}>
                        {(['1'].includes(currentStatus) || userManagementSearch.inactive_pending_request === 1 || userManagementSearch.remap_pending_request === 1) ? <th>
                          <li class="custom-control custom-checkbox">
                            <input id="sli_all" type="checkbox" class="custom-control-input" checked={allSelected} onChange={handleSelectAll} />
                            <label for="sli_all" class="custom-control-label">
                            </label>
                          </li>
                        </th> : <th style={{ width: '2%' }}></th>}
                      </WithRights>
                      <th>Name<span onClick={() => toggleSort('user_name')} title="" className="tooltio-ic"><i className={(sortToggle.user_name) ? 'sorting_asc' : 'sorting_desc'}></i></span></th>
                      <th>SFA ID</th>
                      <th>Email</th>
                      <th>Mobile</th>
                      <th>User Role</th>
                      {currentStatus !== REJECT_STATUS && !userManagementSearch.rejected_inactive_request &&
                        <th>Primary Manager<span onClick={() => toggleSort('reporting_role_name')} title="" className="tooltio-ic"><i className={(sortToggle.reporting_role_name) ? 'sorting_asc' : 'sorting_desc'}></i></span></th>
                      }
                      {(currentStatus === REJECT_STATUS || userManagementSearch.rejected_inactive_request === 1 || userManagementSearch.rejected_remap_request === 1) &&
                        <th>Reason For Rejection</th>
                      }
                      {userManagementSearch.inactive_pending_request !== 1 && !userManagementSearch.rejected_inactive_request && userManagementSearch.remap_pending_request !== 1 && !userManagementSearch.rejected_remap_request && <th>Status</th>}
                      {userManagementSearch.inactive_pending_request === 1 && <th>Reason for Inactive</th>}
                      {userManagementSearch.rejected_inactive_request === 1 && <th>Status</th>}
                      {(userManagementSearch.remap_pending_request === 1 || userManagementSearch.rejected_remap_request === 1) && <th>Requested Primary Manager</th>}
                      {userManagementSearch.rejected_remap_request === 1 && <th>Status</th>}
                      <th>Created Date<span onClick={() => toggleSort('created_date')} title="" className="tooltio-ic"><i className={(sortToggle.created_date) ? 'sorting_asc' : 'sorting_desc'}></i></span></th>
                      <th>Business Line</th>
                      <th>Business Unit</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {userList && userList.user_list && userList.user_list.length === 0 ? <tr><td align="center" colSpan="11"><h6 className="text-center text-danger text-bold">No Records Found</h6></td></tr> : null}
                    {
                      userList && userList.user_list && userList.user_list.length !== 0 && userList.user_list.map((userdata, k) => (
                        <tr key={k} >
                          <WithRights rightKey="update_user_mapping" fallback={<td style={{ width: '2px' }}></td>} >
                            {(['1'].includes(currentStatus) || userManagementSearch.inactive_pending_request === 1 || userManagementSearch.remap_pending_request === 1) ? <td>
                              <li class="custom-control custom-checkbox">
                                <input id={`sli${k}`} type="checkbox" class="custom-control-input" checked={userdata.is_selected} onChange={() => handleSelectOne(k)} />
                                <label for={`sli${k}`} class="custom-control-label">
                                </label>
                              </li>
                            </td> : <td style={{ width: '2px' }}></td>}
                          </WithRights>
                          <td>{userdata.name}</td>
                          <td>{userdata.userId}</td>
                          <td title={userdata.email}>{userdata.email}</td>
                          <td>{userdata.mobile}</td>
                          <td>{userdata.role_name}</td>
                          {userdata.status !== REJECT_STATUS && !userManagementSearch.rejected_inactive_request &&
                            <td>{userdata.reporting_to}<br />-
                              {(TENANT === TENANTS.PH) ? RoleId[userdata.manager_role_id] : RoleId[userdata.reporting_to_role]}</td>}
                          {userManagementSearch.rejected_inactive_request === 1 && <td>
                            <span>{userdata.inactive_request_rejection_reason}</span>
                          </td>}
                          {userManagementSearch.rejected_remap_request === 1 && <td>
                            <span>{userdata.remap_request_rejection_reason}</span>
                          </td>}
                          {userdata.status === REJECT_STATUS && !userManagementSearch.rejected_inactive_request && <td>
                            <div className='d-flex'>
                              <span>{userdata.rejection_reason} </span>
                              {userdata.rejection_reason === "Others" &&
                                <div id='others_reason_tooltip'>
                                  <Tooltip
                                    useContext
                                    html={(
                                      <div className="controlled-example tooltip-main">
                                        <div className="tooltip-data">
                                          <span>{userdata.rejection_reason_comment}</span>
                                        </div>
                                      </div>
                                    )}
                                    className="tootip-outer"
                                    // open="true"
                                    theme="light"
                                    size="regular"
                                    position="bottom"
                                    trigger="click"
                                  >
                                    <span title="" className="tooltio-ic"> <i className='ic-info-icon1'></i>
                                    </span>
                                  </Tooltip>
                                </div>
                              }
                            </div>
                          </td>
                          }
                          {userManagementSearch.rejected_remap_request === 1 && <td>
                            <div className='d-flex'>
                              <span>{userdata.requested_remap_manager_name} - {userdata.requested_remap_manager_role_name}</span>
                            </div>
                          </td>}
                          <td>
                            {userManagementSearch.rejected_inactive_request === 1 && <span className='status-inactive'>Rejected</span>}
                            {userManagementSearch.rejected_remap_request === 1 && <span className='status-inactive'>Rejected</span>}
                            {userManagementSearch.remap_pending_request === 1 && <div className='d-flex'>
                              <span>{userdata.requested_remap_manager_name} - {userdata.requested_remap_manager_role_name}</span>
                            </div>}
                            {userManagementSearch.inactive_pending_request === 1 && <div className='d-flex'>
                              <span>{userdata.user_inactive_status_name}-{userdata.inactive_request_reason} </span>
                              {userdata.inactive_reason_request_comment &&
                                <div id='others_reason_request_tooltip'>
                                  <Tooltip
                                    useContext
                                    html={(
                                      <div className="controlled-example tooltip-main">
                                        <div className="tooltip-data">
                                          <span>{userdata.inactive_reason_request_comment}</span>
                                        </div>
                                      </div>
                                    )}
                                    className="tootip-outer"
                                    // open="true"
                                    theme="light"
                                    size="regular"
                                    position="bottom"
                                    trigger="click"
                                  >
                                    <span title="" className="tooltio-ic"> <i className='ic-info-icon1'></i>
                                    </span>
                                  </Tooltip>
                                </div>
                              }
                            </div>
                            }
                            {userManagementSearch.inactive_pending_request !== 1 && !userManagementSearch.rejected_inactive_request && userManagementSearch.remap_pending_request !== 1 && !userManagementSearch.rejected_remap_request && <div className='d-flex'>
                              <span className={getClassName(userdata.status)}>{userdata.status_name} </span>
                              {userdata.status === "4" && parseInt(userdata.role_id) === ((TENANT === TENANTS.OTO || TENANT === TENANTS.TRIV) ? parseInt(Role.Agent) : parseInt(Role.FA)) && (parseInt(userdata.is_call_verified) === 1 || parseInt(userdata.is_docs_verified) === 1) &&
                                <div id='sub_status_tooltip'>
                                  <Tooltip
                                    useContext
                                    html={(
                                      <div className="controlled-example tooltip-main">
                                        <div className="tooltip-data tootip-outer">
                                          <ul className="user-detail">
                                            {userdata.is_call_verified === 1 ? <li className='popup-list'>Call Verified</li> : ""}
                                            {userdata.is_docs_verified === 1 ? <li className='popup-list'>Docs Verified</li> : ""}
                                          </ul>
                                        </div>
                                      </div>
                                    )}
                                    className="tootip-outer"
                                    theme="light"
                                    size="regular"
                                    position="bottom"
                                    trigger="click"
                                  >
                                    <span title="" className="tooltio-ic"> <i className='ic-info-icon1'></i>
                                    </span>
                                  </Tooltip>
                                </div>
                              }
                              {userdata.status === "0" && userdata.inactive_reason &&
                                <div id='sub_status_tooltip'>
                                  <Tooltip
                                    useContext
                                    html={(
                                      <div className="controlled-example tooltip-main">
                                        <div className="tooltip-data">
                                          <span>{userdata.inactive_reason + " - "}</span><br />
                                          <span>{userdata.inactive_reason_comment}</span>
                                        </div>
                                      </div>
                                    )}
                                    className="tootip-outer"
                                    theme="light"
                                    size="regular"
                                    position="bottom"
                                    trigger="click"
                                  >
                                    <span title="" className="tooltio-ic"> <i className='ic-info-icon1'></i>
                                    </span>
                                  </Tooltip>
                                </div>
                              }
                            </div>
                            }
                          </td>
                          <td>{DateFormat(new Date(((userManagementSearch.remap_pending_request === 1 || userManagementSearch.rejected_remap_request === 1) && userdata.remap_requested_date) ? userdata.remap_requested_date : userdata.created_date), 'dd mmm, yyyy')}</td>
                          <td>{userdata.business_line}</td>
                          <td>{userdata.business_unit || (TENANT === TENANTS.PH ? 'Carmudi' : '')}</td>
                          <td>
                            <ul class="action-btn">
                              {/* <WithRights rightKey="edit_agent">
                                {(hasRights, loginUserInfo) => {
                                  // Extract the necessary properties from userdata and loginUserInfo
                                  const { role_id: userRoleId } = userdata;
                                  const { admin_role_id: adminRoleId } = loginUserInfo.user_data;

                                  // Determine if the edit action should be displayed based on the conditions
                                  const restrictAgentEditing = hasRights && (
                                    adminRoleId !== ADMIN_ROLES['sales_support'] || // If adminRole is not 5, allow editing for any status
                                    !(adminRoleId === ADMIN_ROLES['sales_support'] && userRoleId === Role['Agent'] && ["0", "3", "4", ""].includes(currentStatus)) // If adminRole is 5, do not allow editing if the userRoleId is 53 and currentStatus is 0, 3, or 4
                                  );

                                  // Render the button if the conditions are met
                                  return restrictAgentEditing ? (
                                    <li>
                                      <a className="btn btn-default" onClick={() => handleView(userdata.userId)}>
                                        <i className="ic-remove_red_eyevisibility"></i>
                                      </a>
                                    </li>
                                  ) : null;
                                }}
                              </WithRights> */}

                              {
                                (restrictAgentEditing(userdata.role_id)) && (
                                  <li>
                                    <a className="btn btn-default" href={false} onClick={() => handleView(userdata.user_id_hash)}>
                                      <i className="ic-remove_red_eyevisibility"></i>
                                    </a>
                                  </li>
                                )
                              }

                              <li onClick={() => showModalUserHistoryPopup(userdata.user_id_hash, userdata.role_id)}>
                                <i class="ic-Call-history"></i>
                              </li>
                              {(parseInt(userdata.role_id) === parseInt(Role.BM) && (userdata.signature_status === 0 || userdata.signature_status === 1)) && <li onClick={() => showModalApproveEsign(userdata.userId)}>
                                <i class="ic-reassign"></i>
                              </li>}
                              <WithRights rightKey="log_out_user">
                                {
                                  (userdata.device_id && userdata.device_id !== '') ?

                                    <a target="_self" href={() => false} className='anchor-txt' onClick={() => forceLogout(userdata.userId)}>Logout</a> : <p>Logged Out</p>
                                }
                              </WithRights>

                            </ul>
                          </td>
                        </tr>
                      ))
                    }
                  </tbody>
                </table>
                <div className='pagination-bx' id="dealerList">
                  <ReactPaginate
                    previousLabel={"<"}
                    nextLabel={">"}
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    forcePage={offset}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    subContainerClassName={"pages pagination"}
                    activeClassName={"active"} />
                </div >
              </div>
            </Tab.Container>
          </div>
        </div>
        <div className="model-popup-outer role-history-popup">
          <Modal show={UserHistoryPopup} handleClose={hideModalUserHistoryPopup} >
            <div className="modal-header">
              <h2>User Timeline</h2>
            </div>

            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
              <Nav variant="pills" className="flex-column tab-line nav nav-pills">
                <div className="tab-list">
                  <Nav.Item>
                    <Nav.Link eventKey="first">Role History</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="second">Account History</Nav.Link>
                  </Nav.Item>
                  {TENANT === TENANTS.OTO && parseInt(activeRoleId) === parseInt(Role.Agent) &&
                    <Nav.Item>
                      <Nav.Link eventKey="third">Vendor History</Nav.Link>
                    </Nav.Item>
                  }
                  {(TENANT === TENANTS.OTO) &&
                    <Nav.Item>
                      <Nav.Link eventKey="fourth">Journey History</Nav.Link>
                    </Nav.Item>
                  }
                  {((TENANT === TENANTS.OTO || TENANT === TENANTS.TRIV) ? parseInt(activeRoleId) === parseInt(Role.BM) : parseInt(activeRoleId) === parseInt(Role.MM)) &&
                    <Nav.Item>
                      <Nav.Link eventKey="fifth">{(TENANT === TENANTS.OTO || TENANT === TENANTS.TRIV) ? "BM Grading History" : "MM Grading History"}</Nav.Link>
                    </Nav.Item>
                  }
                  {((TENANT === TENANTS.OTO || TENANT === TENANTS.TRIV) ? parseInt(activeRoleId) === parseInt(Role.Agent) : parseInt(activeRoleId) === parseInt(Role.FA)) &&
                    <Nav.Item>
                      <Nav.Link eventKey="sixth">App History</Nav.Link>
                    </Nav.Item>
                  }
                </div>
              </Nav>
              <div className='modal-body' >
                <Tab.Content>
                  <Tab.Pane eventKey="first">
                    <div className='data-table'>
                      <table>
                        <thead>
                          <tr>
                            <th>Created On</th>
                            <th>Role</th>
                            <th>Tagging</th>
                            {(TENANT !== TENANTS.PH) && <th>Primary Manager</th>}
                            <th>Business Line</th>
                            <th>Status</th>
                            <th>Joining Date</th>
                            {(TENANT !== TENANTS.PH) && <th>Mobile</th>}
                            <th>Created By</th>
                          </tr>
                        </thead>
                        <tbody>
                          {UserRoleHistoryList && UserRoleHistoryList.length === 0 ? <tr><td align="center" colSpan="8"><h6 className="text-center text-danger text-bold">No Records Found</h6></td></tr> : null}
                          {
                            UserRoleHistoryList && UserRoleHistoryList.length !== 0 && UserRoleHistoryList.map((userhistorydata, k) => (
                              <tr key={k} >
                                <td><span>{DateFormat(new Date(userhistorydata.created_date), 'dd mmm, yyyy')}</span></td>
                                <td>{userhistorydata.role_name}</td>
                                <td>{userhistorydata.tagging_name}</td>
                                {(TENANT !== TENANTS.PH) && <td>{userhistorydata.manager_name ? userhistorydata.manager_name + "(" + userhistorydata.manager_id + ") - " + RoleId[userhistorydata.manager_role_id] : ""}</td>}
                                <td>{userhistorydata.business_line}</td>
                                <td>{userhistorydata.user_status_name}</td>
                                <td>{userhistorydata.doj}</td>
                                {(TENANT !== TENANTS.PH) && <td>{userhistorydata.mobile}</td>}
                                {(TENANT === TENANTS.PH) ?
                                  <td>{(userhistorydata.action_via === 'admin') ? userhistorydata.display_name : userhistorydata.created_by}</td> :
                                  <td>{(userhistorydata.action_via === 'admin' && userhistorydata.display_name && userhistorydata.created_by_id) ? "Admin-" + userhistorydata.display_name + "-" + userhistorydata.created_by_id : (userhistorydata.action_via === 'user' && userhistorydata.created_by && userhistorydata.created_by_id) ? "SFA User-" + userhistorydata.created_by + "-" + userhistorydata.created_by_id : ""}</td>
                                }
                              </tr>
                            ))
                          }
                        </tbody>
                      </table>
                    </div>

                  </Tab.Pane>
                  <Tab.Pane eventKey="second">
                    <div className='data-table'>
                      <table>
                        <thead>
                          <tr>
                            <th>Created On</th>
                            <th>Account Number</th>
                            <th>Beneficiary Name</th>
                            <th>Branch Name</th>
                            <th>Bank Name</th>
                            {(TENANT !== TENANTS.PH) && <th>NPWP</th>}
                            <th>Created By</th>
                          </tr>
                        </thead>
                        <tbody>
                          {UserAccountHistoryList && UserAccountHistoryList.length === 0 ? <tr><td align="center" colSpan="6"><h6 className="text-center text-danger text-bold">No Records Found</h6></td></tr> : null}
                          {
                            UserAccountHistoryList && UserAccountHistoryList.length !== 0 && UserAccountHistoryList.map((useraccountdata, k) => (
                              <tr key={k} >
                                <td><span>{DateFormat(new Date(useraccountdata.created_date), 'dd mmm, yyyy')}</span></td>
                                <td>{useraccountdata.account_number}</td>
                                <td className="truncate">{useraccountdata.beneficiary_name}</td>
                                <td>{useraccountdata.branch_name}</td>
                                <td>{useraccountdata.bank_name}</td>
                                {(TENANT !== TENANTS.PH) && <td>{useraccountdata.npwp}</td>}
                                <td>{(useraccountdata.action_via === 'admin') ? useraccountdata.display_name : useraccountdata.created_by}</td>
                              </tr>
                            ))
                          }
                        </tbody>
                      </table>
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="third">
                    <div className='data-table'>
                      <table>
                        <thead>
                          <tr>
                            <th>Created On</th>
                            <th>Type</th>
                            <th>Status</th>
                            <th>Vendor ID</th>
                          </tr>
                        </thead>
                        <tbody>
                          {VendorHistoryList && VendorHistoryList.length === 0 ? <tr><td align="center" colSpan="4"><h6 className="text-center text-danger text-bold">No Records Found</h6></td></tr> : null}
                          {
                            VendorHistoryList && VendorHistoryList.length !== 0 && VendorHistoryList.map((uservendordata, k) => (
                              <tr key={k} >
                                <td><span>{DateFormat(new Date(uservendordata.created_date), 'dd mmm, yyyy')}</span></td>
                                <td>{uservendordata.show_type}</td>
                                <td>{uservendordata.show_response_status}</td>
                                <td>{uservendordata.vendor_id}</td>
                              </tr>
                            ))
                          }
                        </tbody>
                      </table>
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="fourth">
                    <div className='data-table'>
                      <table>
                        <thead>
                          <tr>
                            <th>Date & Time</th>
                            {/* <th>Current Role/Tagging</th> */}
                            <th>Recommended Role/Tagging</th>
                            <th>Recommended By</th>
                            <th>Comments</th>
                          </tr>
                        </thead>
                        <tbody>
                          {ProgressionHistoryList && ProgressionHistoryList.length === 0 ? <tr><td align="center" colSpan="4"><h6 className="text-center text-danger text-bold">No Records Found</h6></td></tr> : null}
                          {
                            ProgressionHistoryList && ProgressionHistoryList.length !== 0 && ProgressionHistoryList.map((userprogressiondata, k) => (
                              <tr key={k} >
                                <td><span>{DateFormat(new Date(userprogressiondata.created_date), 'dd mmm, yyyy h:MM TT')}</span></td>
                                {/* <td>{(userprogressiondata.current_role?userprogressiondata.current_role:"")+"/"+(userprogressiondata.current_tagging?userprogressiondata.current_tagging:"")}</td> */}
                                <td>{(userprogressiondata.recommended_role ? userprogressiondata.recommended_role : "") + "/" + (userprogressiondata.recommended_tagging ? userprogressiondata.recommended_tagging : "")}</td>
                                <td style={{ textTransform: "capitalize" }}>{userprogressiondata.recommended_by ? userprogressiondata.recommended_by : ""}</td>
                                <td>{userprogressiondata.comment ? <Tooltip
                                  useContext
                                  html={(
                                    <div className="controlled-example tooltip-main">
                                      <div className="tooltip-data tootip-outer">
                                        <h3 className="subheading">{userprogressiondata.comment}</h3>
                                      </div>
                                    </div>
                                  )}
                                  className="tootip-outer"
                                  // open="true"
                                  theme="light"
                                  size="regular"
                                  position="bottom"
                                  trigger="click"
                                >
                                  <span>{(userprogressiondata.comment) ? (userprogressiondata.comment.length > 10) ? userprogressiondata.comment.substr(0, 10) + "..." : userprogressiondata.comment : ''}</span>
                                </Tooltip> : ""}</td>
                              </tr>
                            ))
                          }
                        </tbody>
                      </table>
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="fifth">
                    <div className='data-table'>
                      <table>
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Grade</th>
                            <th>Updated By</th>
                          </tr>
                        </thead>
                        <tbody>
                          {BMGradingHistoryList && BMGradingHistoryList.length === 0 ? <tr><td align="center" colSpan="3"><h6 className="text-center text-danger text-bold">No Records Found</h6></td></tr> : null}
                          {
                            BMGradingHistoryList && BMGradingHistoryList.length !== 0 && BMGradingHistoryList.map((userbmgradingdata, k) => (
                              <tr key={k} >
                                <td><span>{DateFormat(new Date(userbmgradingdata.updated_date), 'dd mmm, yyyy')}</span></td>
                                <td>{userbmgradingdata.bm_grade}</td>
                                <td>{userbmgradingdata.created_by ? userbmgradingdata.created_by : "System"}</td>
                              </tr>
                            ))
                          }
                        </tbody>
                      </table>
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="sixth">
                    <div className='data-table'>
                      <table>
                        <thead>
                          <tr>
                            <th>Created Date</th>
                            <th>First Login</th>
                            <th>Last Log in</th>
                          </tr>
                        </thead>
                        <tbody>
                          {AppUsageList && AppUsageList.length === 0 ? <tr><td align="center" colSpan="3"><h6 className="text-center text-danger text-bold">No Records Found</h6></td></tr> : null}
                          {
                            AppUsageList && AppUsageList.length !== 0 && AppUsageList.map((userData, k) => (
                              <tr key={k} >
                                <td><span>{DateFormat(new Date(userData.created_date), 'dd mmm, yyyy')}</span></td>
                                <td><span>{DateFormat(new Date(userData.first_login_date), 'dd mmm, yyyy')}</span></td>
                                <td><span>{DateFormat(new Date(userData.last_login_date), 'dd mmm, yyyy')}</span></td>
                              </tr>
                            ))
                          }
                        </tbody>
                      </table>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </div>

            </Tab.Container>
          </Modal>
          <ChangeMappingModal show={changeMapping} handleClose={hidechangeMappingPopup} >
            <div className="modal-header">
              <h2>Change Mapping</h2>
            </div>
            {changeMapping ? <ChangeMappingPopUp {...{ RoleData, ReportingRole, ReportingTo, userList, currentChangeManagerRole, currentBusinessLine, currentBusinessUnitId, currentBusinessVerticalId }} /> : null}

          </ChangeMappingModal>

          <ChangeMappingModal show={changeTagging} handleClose={hidechangeTaggingPopup} >
            <div className="modal-header">
              <h2>Change Agent Tagging</h2>
            </div>
            {changeTagging ? <ChangeTaggingPopUp {...{ RoleData, TaggingOption, userList }} /> : null}

          </ChangeMappingModal>


          <ChangeMappingModal show={markInactive} handleClose={hideMarkInactivePopup} height="510px">
            <div className="modal-header">
              <h2>Are you sure you want to Marked users as Inactive?</h2>
            </div>
            {markInactive ? <MarkInactivePopup {...{ TaggingOption, userList, inactive_pending_request: userManagementSearch.inactive_pending_request, onClose: hideMarkInactivePopup, onSuccess: hideMarkInactivePopup }} /> : null}
          </ChangeMappingModal>

          <ChangeMappingModal show={rejectRequest} handleClose={hideRejectRequestPopup} height="510px">
            <div className="modal-header">
              <h2>Are you sure you want to reject this inactive request?</h2>
            </div>
            {rejectRequest ? <RejectRequestPopup {...{ userList, onClose: hideRejectRequestPopup, onSuccess: hideRejectRequestPopup }} /> : null}
          </ChangeMappingModal>

          <ChangeMappingModal show={rejectRemapRequest} handleClose={hideRejectRemapRequestPopup} height="510px">
            <div className="modal-header">
              <h2>Are you sure you want to reject this remap request?</h2>
            </div>
            {rejectRemapRequest ? <RejectRemapRequestPopup {...{ userList, onClose: hideRejectRemapRequestPopup, onSuccess: hideRejectRemapRequestPopup }} /> : null}
          </ChangeMappingModal>

          <ChangeMappingModal show={approveRemapRequest} handleClose={hideApproveRemapRequestPopup} height="290px">
            <div className="modal-header">
              <h2>Are you sure you want to approve this remap request?</h2>
            </div>
            <div className="modal-body" style={{ paddingBottom: "30px" }}>
              <p>The selected user(s) will be remapped to the Requested Primary Manager.</p>
              <div className="text-center" style={{ display: "flex", justifyContent: "center", gap: "10px", marginTop: "40px" }}>
                <button type="button" className="btn-line" onClick={hideApproveRemapRequestPopup}>No</button>
                <button type="button" className="btn-primary" onClick={handleApproveRemapRequest}>Yes</button>
              </div>
            </div>
          </ChangeMappingModal>
        </div>
        <div className='model-popup-outer export-userdata-popup'>
          <Modal show={exportOptionModal} handleClose={hideExportClose} >
            <div className="modal-header">
              <h2>Export Data</h2>
            </div>
            <div className="modal-body export-option max-h">
              <div className="lead-list-filter p-rel">
                <div className="filter-filed-form">
                  <div className='d-flex export-data-filter'>
                    <h3>Select Fields</h3>
                    {exportFormField && Object.keys(exportFormField).length > 0 &&
                      Object.keys(exportFormField).map((element, index) => (
                        exportFormField[element] && exportFormField[element].length > 0 && (
                          <fieldset key={index} className="multiselect-dropDown">
                            <div className="material">
                              <ReactMultiSelectCheckboxes
                                options={[{ field_label: "Select All", field_name: "*" }, ...exportFormField[element]]}
                                value={
                                  export_field_data[element]?.length === exportFormField[element]?.length && exportFormField[element].length > 0
                                    ? [{ field_label: "Select All", field_name: "*" }, ...exportFormField[element]]
                                    : export_field_data[element]
                                }
                                onChange={handleChangeExportField.bind(this, element)}
                                name={element}
                                id={element}
                                placeholder={element}
                                isDisabled={false}
                                isClearable={true}
                                getOptionLabel={({ field_label }) => field_label}
                                getOptionValue={({ field_name }) => field_name}
                              />
                            </div>
                          </fieldset>
                        )
                      ))
                    }
                  </div>
                </div>
                <div className='select-field-heading'>Fields Selected</div>
                <div className='d-flex export-data-selected-filed'>
                  <div className='sfa-id-checkbox'>
                    <h3>SFA ID</h3>
                    <li className="custom-control custom-checkbox">
                      <input
                        id={`sfa_id`}
                        type="checkbox"
                        name="sfa_id"
                        className="custom-control-input"
                        isDisabled={true}
                        checked={true}
                      />
                      <label htmlFor={`sfa_id`} className="custom-control-label">
                      </label>
                      <span>SFA ID</span>
                    </li>
                  </div>

                  {/* div to show export field */}
                  {export_field_data && Object.keys(export_field_data).length > 0 && Object.keys(export_field_data).map((parent_element, parent_index) => (
                    <div key={parent_index} className={parent_element === 'Basic Details' ? 'listing_basic_outer export_data_list' : 'export_data_list'}>
                      <h3>{parent_element}</h3>
                      <div className={parent_element === 'Basic Details' ? 'listing_basic' : 'listing'}>
                        {export_field_data[parent_element] && export_field_data[parent_element].length > 0 && export_field_data[parent_element].filter(e => e.field_name !== "*").map((element, index) => (
                          <span key={index}>{element.field_label}</span>
                        ))}
                      </div>
                    </div>
                  ))}
                  {/* end of div to show export field */}
                </div>

              </div>
            </div>
            <div className='export_buttons f-right p-md-t'>
              <button onClick={() => { downloadUserData('download') }} className='btn-primary m-sm-r'>Download</button>
              <button onClick={() => { downloadUserData('email') }} className='btn-primary'>Email</button>
            </div>
          </Modal>
        </div>
        <div className='model-popup-outer export-userdata-popup'>
          <Modal show={EsignApproveUserPopup} handleClose={hideModalApproveEsign} >
            <div className="modal-header">
              <h2>Verify User Sign</h2>
            </div>
            <div className='modal-body'>
              <div className='data-table esignature_outerview'>
                <table>
                  <tbody>
                    <tr>
                      <th>KTP ID Preview</th>
                      <th>Uploaded Signature</th>
                    </tr>
                    <tr>
                      <td> <div className="preview-img">
                        <img alt="" src={SignatureData.ktp_doc_url} />
                      </div></td>
                      <td> <div className="preview-img signature-preview">
                        <img alt="" src={SignatureData.signature_url} />
                      </div></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className='modal-footer'>
              {parseInt(SignatureData.signature_status) === 0 && <div className='export_buttons f-right p-md-t'>
                <button onClick={() => { esignApproveSignature(1, SignatureData.user_id) }} className='btn-primary m-sm-r'>Verify</button>
                <button onClick={() => { esignApproveSignature(2, SignatureData.user_id) }} className='btn-line btn-reject-verified'>Reject Verification</button>
              </div>
              }
              {parseInt(SignatureData.signature_status) === 1 && <div className='export_buttons f-right p-md-t'>
                <button className='btn-primary btn-verified m-sm-r'>Verified</button>
              </div>
              }
            </div>
          </Modal>
        </div>
      </div>
    </React.Fragment>
  )
}
const CustomValueContainer = ({ children, ...props }) => {
  return (
    <ValueContainer {...props}>
      <Placeholder {...props} isFocused={props.isFocused}>
        {props.selectProps.placeholder}
      </Placeholder>
      {React.Children.map(children, child =>
        child && child.type !== Placeholder ? child : null
      )}
    </ValueContainer>
  );
};
const Modal = ({ handleClose, show, children }) => {
  const showHideClassName = show ? 'modal display-block' : 'modal display-none';

  return (
    <div className={showHideClassName}>
      <section className='modal-main'>
        {children}
        <button
          onClick={handleClose}
          className="close_icn"
        >
          <i className="ic-clearclose"></i>
        </button>
      </section>
    </div>
  );
};

const ChangeMappingModal = ({ handleClose, show, children, height }) => {
  const showHideClassName = show ? 'modal display-block' : 'modal display-none';

  return (
    <div className={showHideClassName}>
      <section className='modal-main' style={{ width: "650px", height: height || "300px" }}>
        {children}
        <button
          onClick={handleClose}
          className="close_icn"
        >
          <i className="ic-clearclose"></i>
        </button>
      </section>
    </div>
  );
};


export default UserManagementDetail;